import React from 'react';

const galleryImages = [
  'https://customer-assets.emergentagent.com/job_058bccbf-ae46-496f-9a9e-541820fd866a/artifacts/3ic4bwkj_98ff289b-206b-4109-bc93-b20ff099aaee.JPG',
  'https://customer-assets.emergentagent.com/job_058bccbf-ae46-496f-9a9e-541820fd866a/artifacts/bus1hgxu_2368418d-b426-4c6e-9ab1-c46d0a54c815%202.JPG',
  'https://customer-assets.emergentagent.com/job_058bccbf-ae46-496f-9a9e-541820fd866a/artifacts/87rskvnq_8108210b-8bfc-48f0-9a11-297980d55850.JPG',
  'https://customer-assets.emergentagent.com/job_058bccbf-ae46-496f-9a9e-541820fd866a/artifacts/ktiuwtvn_a9c61c26-9b2d-4534-bc56-0a3a8d82ab3d.JPG',
  'https://customer-assets.emergentagent.com/job_058bccbf-ae46-496f-9a9e-541820fd866a/artifacts/8jp2qksp_c7ed42f0-a87d-405c-8132-2199f4e5c8fe.JPG',
  'https://customer-assets.emergentagent.com/job_058bccbf-ae46-496f-9a9e-541820fd866a/artifacts/o7x1s24t_c21c64cc-3f89-4a14-b8e9-97d14d8ec707.JPG',
  'https://customer-assets.emergentagent.com/job_058bccbf-ae46-496f-9a9e-541820fd866a/artifacts/yo8c3vda_d0e7659d-5cf0-4751-8199-9e34fead3f23%202.JPG',
  'https://customer-assets.emergentagent.com/job_058bccbf-ae46-496f-9a9e-541820fd866a/artifacts/jqi4369j_fa00cf58-a61a-4907-8be0-7b01ded9ce7c.JPG',
  'https://customer-assets.emergentagent.com/job_058bccbf-ae46-496f-9a9e-541820fd866a/artifacts/b3jkqtdy_IMG_4180.jpg',
];

const Gallery = () => {
  // Duplicate images for seamless infinite scroll
  const duplicatedImages = [...galleryImages, ...galleryImages];

  return (
    <section id="gallery" className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-6 mb-12">
        <div className="text-center">
          <div className="text-cyan-800 text-sm font-semibold tracking-wider uppercase mb-4">
            OUR GALLERY
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Home Theatre Designs
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Explore our stunning home theatre installations
          </p>
        </div>
      </div>

      {/* Auto-scrolling Gallery */}
      <div className="relative w-full overflow-hidden">
        <div 
          className="flex gap-4 animate-scroll"
          style={{
            width: 'max-content',
          }}
        >
          {duplicatedImages.map((image, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-72 h-72 group relative overflow-hidden rounded-2xl border-2 border-cyan-700/30 hover:border-cyan-700 transition-all duration-300"
            >
              <img
                src={image}
                alt={`Gallery ${(index % galleryImages.length) + 1}`}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Hover Overlay */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-12 h-12 border-2 border-white rounded-full flex items-center justify-center bg-white/20 backdrop-blur-sm">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CSS Animation */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default Gallery;
